import { render, staticRenderFns } from "./shopList.vue?vue&type=template&id=caf9eb34&scoped=true&"
import script from "./shopList.vue?vue&type=script&lang=js&"
export * from "./shopList.vue?vue&type=script&lang=js&"
import style0 from "./shopList.vue?vue&type=style&index=0&id=caf9eb34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf9eb34",
  null
  
)

export default component.exports